const TermsOfUse = () => {
  return (
    <div className="max-w-5xl mx-auto px-6 py-16 text-gray-800">

      <h1 className="text-3xl font-bold mb-4">Terms of Use</h1>
      <p className="text-sm text-gray-500 mb-8">
        Last Updated: 05 April 2026
      </p>

      <p className="mb-6 leading-relaxed">
        Welcome to the Beneicon website. These Terms of Use govern your access 
        to and use of our website, including all content, information, and 
        services available through the site.
      </p>

      <p className="mb-8 font-medium">
        By accessing or using this website, you agree to comply with these Terms 
        of Use. If you do not agree with these terms, you should not use this website.
      </p>

      {/* Section 1 */}
      <h2 className="text-xl font-semibold mb-3">1. About Beneicon</h2>
      <p className="mb-8 leading-relaxed">
        Beneicon is a technology-driven company specializing in LED display 
        solutions, including digital standees, indoor and outdoor LED video walls, 
        and customized display systems for commercial and advertising applications.
        The information presented on this website is intended for general informational 
        purposes regarding Beneicon’s products, capabilities, and services.
      </p>

      {/* Section 2 */}
      <h2 className="text-xl font-semibold mb-3">2. Acceptance of Terms</h2>
      <p className="mb-4 leading-relaxed">
        By accessing this website, you confirm that you:
      </p>
      <ul className="list-disc pl-6 mb-4 space-y-2">
        <li>Agree to these Terms of Use</li>
        <li>Will comply with applicable laws and regulations</li>
        <li>Will use the website responsibly and ethically</li>
      </ul>
      <p className="mb-8 leading-relaxed">
        Beneicon reserves the right to update or modify these terms at any time. 
        Continued use of the website after changes are published constitutes 
        acceptance of the revised terms.
      </p>

      {/* Section 3 */}
      <h2 className="text-xl font-semibold mb-3">3. Use of Website Content</h2>
      <p className="mb-4 leading-relaxed">
        All content available on this website, including:
      </p>
      <ul className="list-disc pl-6 mb-4 space-y-2">
        <li>Text</li>
        <li>Graphics</li>
        <li>Product visuals</li>
        <li>Technical specifications</li>
        <li>Brand assets</li>
        <li>Design elements</li>
      </ul>
      <p className="mb-4">is the property of Beneicon unless otherwise stated.</p>

      <p className="mb-2 font-medium">You may:</p>
      <ul className="list-disc pl-6 mb-4 space-y-2">
        <li>View website content for personal or informational use</li>
        <li>Share links to our website with proper attribution</li>
      </ul>

      <p className="mb-2 font-medium">You may not:</p>
      <ul className="list-disc pl-6 mb-8 space-y-2">
        <li>Copy, reproduce, republish, or distribute content for commercial purposes</li>
        <li>Modify or create derivative works from website materials</li>
        <li>Use Beneicon branding without prior written permission</li>
      </ul>

      {/* Section 4 */}
      <h2 className="text-xl font-semibold mb-3">4. Website Access and Use</h2>
      <p className="mb-4">You agree not to:</p>
      <ul className="list-disc pl-6 mb-8 space-y-2">
        <li>Attempt to gain unauthorized access to any part of the website</li>
        <li>Interfere with website functionality or security</li>
        <li>Use automated tools to scrape or extract data</li>
        <li>Engage in any activity that could harm or disrupt the website</li>
      </ul>
      <p className="mb-8 leading-relaxed">
        Beneicon reserves the right to restrict or terminate access for users who 
        violate these terms.
      </p>

      {/* Section 5 */}
      <h2 className="text-xl font-semibold mb-3">5. No Professional Advice</h2>
      <p className="mb-8 leading-relaxed">
        The content provided on this website is for informational purposes only 
        and does not constitute professional technical, financial, legal, or 
        business advice. Any formal purchase, installation, or service engagement 
        with Beneicon will be governed by a separate written agreement or quotation.
      </p>

      {/* Section 6 */}
      <h2 className="text-xl font-semibold mb-3">6. Third-Party Links</h2>
      <p className="mb-8 leading-relaxed">
        This website may contain links to third-party websites for informational 
        purposes. Beneicon does not control or endorse these external websites and 
        is not responsible for their content, privacy practices, or policies. Users 
        access third-party sites at their own risk.
      </p>

      {/* Section 7 */}
      <h2 className="text-xl font-semibold mb-3">7. Limitation of Liability</h2>
      <p className="mb-4 leading-relaxed">
        While Beneicon strives to provide accurate and up-to-date information, we 
        make no guarantees regarding the completeness, reliability, or accuracy of 
        the content on this website.
      </p>
      <p className="mb-4">Beneicon shall not be liable for:</p>
      <ul className="list-disc pl-6 mb-8 space-y-2">
        <li>Use of this website</li>
        <li>Reliance on information provided</li>
        <li>Website interruptions or technical issues</li>
      </ul>
      <p className="mb-8 font-medium">
        Use of the website is at your own discretion and risk.
      </p>

      {/* Section 8 */}
      <h2 className="text-xl font-semibold mb-3">8. Privacy</h2>
      <p className="mb-8 leading-relaxed">
        Your use of the Beneicon website is also subject to our Privacy Policy, 
        which outlines how personal information is collected, used, and protected. 
        Users are encouraged to review the Privacy Policy for more information.
      </p>

      {/* Section 9 */}
      <h2 className="text-xl font-semibold mb-3">9. Intellectual Property Rights</h2>
      <p className="mb-8 leading-relaxed">
        All trademarks, logos, service marks, and branding displayed on this 
        website are the property of Beneicon unless otherwise indicated. Any 
        unauthorized use of these marks is strictly prohibited.
      </p>

      {/* Section 10 */}
      <h2 className="text-xl font-semibold mb-3">10. Governing Law</h2>
      <p className="mb-8 leading-relaxed">
        These Terms of Use are governed by the laws of India. Any disputes arising 
        from the use of this website shall be subject to the jurisdiction of the 
        courts located in India.
      </p>

      {/* Section 11 */}
      <h2 className="text-xl font-semibold mb-3">11. Contact Information</h2>
      <p className="mb-2">If you have questions regarding these Terms of Use, please contact:</p>
      <p className="mb-2 font-medium">Beneicon</p>
      <p className="mb-2">Email: support@beneicon.com</p>
      <p>Website: www.beneicon.com</p>

    </div>
  );
};

export default TermsOfUse;